import { render, staticRenderFns } from "./intro.vue?vue&type=template&id=33b3767f&scoped=true"
import script from "./intro.vue?vue&type=script&lang=ts"
export * from "./intro.vue?vue&type=script&lang=ts"
import style0 from "./intro.vue?vue&type=style&index=0&id=33b3767f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b3767f",
  null
  
)

export default component.exports